import { registerStoreSpecs } from '@blocksuite/hive/extensions';

registerStoreSpecs();
